import React, { useRef } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import Header from "./components/Header";
import Home from "./pages/Home";
import Editorial from "./pages/Editorial";
import Legales from "./pages/Legales";
import ArticlePage from "./pages/ArticlePage";
import NotFound from "./pages/NotFound";
import Footer from "./components/Footer";
import "./styles/global.css";

function App() {
  const contactRef = useRef(null);

  return (
    <LanguageProvider>
      <Router>
        <Header contactRef={contactRef} />
        <Routes>
          <Route path="/" element={<Home contactRef={contactRef} />} />
          <Route
            path="/editorial"
            element={<Editorial contactRef={contactRef} />}
          />
          <Route path="/articulo/:articleId" element={<ArticlePage />} />
          <Route path="/legales" element={<Legales />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </Router>
    </LanguageProvider>
  );
}

export default App;
